import { useState } from 'react'
import { Car, Bike } from 'lucide-react'
import { cn } from '../../lib/cn'

/**
 * Renders the real transport PNG (served from /brand/<iconUri>) with a lucide
 * fallback if the image is missing. iconUri comes straight from the API
 * (e.g. "booking-car.png").
 */
export function TransportIcon({
  iconUri,
  label,
  className,
}: {
  iconUri?: string
  label: string
  className?: string
}) {
  const [failed, setFailed] = useState(false)
  const Fallback = /moto|bike|bici/i.test(label) ? Bike : Car

  if (failed || !iconUri) {
    return <Fallback className={cn('h-6 w-6', className)} />
  }
  return (
    <img
      src={`/brand/${iconUri}`}
      alt={label}
      onError={() => setFailed(true)}
      className={cn('h-full w-full object-contain', className)}
    />
  )
}
